import React from 'react';
import ProgressBar from './ProgressBar';
import usePresence, { useUltimoValor } from '../../use/usePresence';

interface BarraEnvioProps {
  /** 0 a 100 enquanto sobe; `null` quando não há envio em curso. */
  progresso: number | null;
  label?: string;
}

/**
 * A porcentagem do upload. Entrava animada e sumia no frame — bastava o envio
 * acabar para a barra piscar fora da tela sem nunca mostrar o fim.
 *
 * O número medido é só o que sai daqui: o repasse do backend ao storage vem
 * depois e é invisível. Por isso, ao bater 100%, o texto vira "Enviando…" em vez
 * de mentir que acabou.
 */
export default function BarraEnvio({ progresso, label = 'Envio do arquivo' }: BarraEnvioProps) {
  const { montado, estado } = usePresence(progresso !== null, 180);
  // Sem isto o número some no primeiro frame da saída e a barra sai vazia.
  const valor = useUltimoValor(progresso);

  if (!montado || valor === null) return null;

  return (
    <div
      data-state={estado}
      className="flex items-center gap-2 data-[state=open]:animate-enter data-[state=closed]:animate-exit"
    >
      <ProgressBar valor={valor} className="h-1" label={label} />
      <span className="text-[11px] text-nude-400 dark:text-gray-500 tabular-nums w-16 text-right">
        {valor < 100 ? `${valor}%` : 'Enviando…'}
      </span>
    </div>
  );
}
